import React, { useEffect, useRef, useState } from 'react';
import { showErrorToast, showInfoToast } from '../../../utils/toastHelper';
import { useTranslation } from 'react-i18next';
import { downloadSample, exportOrders } from '../services/inventoryService';
import FileNames from '../../../constants/fileNames';

export default function ImportInventoryModal({
  setImportModal,
  onSuccess,
  handleImportInventory,
  importLoading,
}) {
  const [file, setFile] = useState(null);
  const [importedData, setImportedData] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const fileInputRef = useRef(null);
  const { t } = useTranslation('Import');
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (
        !selectedFile.name.endsWith('.csv') &&
        !selectedFile.name.endsWith('.xlsx')
      ) {
        showErrorToast(t('PLEASE_SELECT_VALID_FILE'));
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        setFile(null);
        return;
      }

      if (selectedFile.size > 2 * 1024 * 1024) {
        showErrorToast(t('FILE_SIZE_EXCEEDS_LIMIT'));
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        setFile(null);
        return;
      }
      setFile(selectedFile);
    }
  };

  const handleConfirmation = () => {
    setConfirmationOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      showInfoToast(t('PLEASE_SELECT_FILE_FIRST'));
      return;
    }

    // Confirm import action
    handleConfirmation();
  };

  const confirmImport = async () => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await handleImportInventory(formData);
    if (response && response.success) {
      setImportedData(response.import_progress);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setFile(null);
    setConfirmationOpen(false);
  };

  const cancelImport = () => {
    setConfirmationOpen(false);
  };

  const handleDownloadSample = async () => {
    const response = await downloadSample(FileNames.INVENTORY_SAMPLE_IMPORT);
  };

  return (
    <div className="import-file modal fade show d-block" id="import-inventory">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="staticBackdropLabel">
              {importedData ? t('IMPORTDETAILS') : t('IMPORTFILE')}
            </h1>
            <button
              //   type="button"
              className="btn-close"
              onClick={() => {
                // if (fileInputRef.current) {
                //   fileInputRef.current.value = ''; // Clear the file input
                // }
                // setFile(null);
                // setImportedData(null);
                // // setImportProgress(null);
                // setConfirmationOpen(false);
                setImportModal(false);
              }}
            ></button>
          </div>
          {confirmationOpen ? (
            <div className="modal-body export-import">
              <h5>
                {t('IMPORTCONFIRMATION', {
                  section: t('INVENTORY'),
                })}
              </h5>
              <div className="d-flex justify-content-between">
                <button
                  onClick={confirmImport}
                  className={`import-btn mt-1 ${importLoading ? 'disable-btn' : ''}`}
                  disabled={importLoading}
                >
                  {t('YESPROCEED')}
                </button>
                <button onClick={cancelImport} className="cancel">
                  {t('NOCANCEL')}
                </button>
              </div>
            </div>
          ) : importedData ? (
            <div className="modal-body">
              <div className="product-inner">
                <div className="import-status mt-3">
                  <h3 className="import-head">{t('IMPORTSTATUS')}</h3>
                  <div className="row">
                    <div className="col-md-6">
                      <p>
                        <strong className="pe-2">{t('STATUS')}:</strong>{' '}
                        {t(importedData.status)}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong className="pe-2">{t('PROCESSEDROWS')}:</strong>{' '}
                        {importedData.processed_rows}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong className="pe-2">{t('SUCCESSFULROWS')}:</strong>{' '}
                        {importedData.success_rows}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong className="pe-2">{t('FAILEDROWS')}:</strong>{' '}
                        {importedData.failed_rows}
                      </p>
                    </div>
                  </div>

                  {importedData.error_message && (
                    <div className="errors">
                      <h4>{t('ERRORS')}:</h4>
                      <ul>
                        {importedData.error_message
                          .split(',')
                          .map((error, index) => (
                            <li key={index}>{error.trim()}</li>
                          ))}
                      </ul>
                    </div>
                  )}
                </div>
                <button
                  type="button"
                  onClick={() => setImportModal(false)}
                  className={`import-btn`}
                >
                  {t('CLOSE')}
                </button>
              </div>
            </div>
          ) : (
            <div className="modal-body">
              <div className="product-inner">
                <label>
                  <form action="">
                    <img src="images/file-download-import-icon 1.svg" alt="" />
                    <p>{t('UPLOADFILE')}...</p>
                    <input
                      ref={fileInputRef}
                      type="file"
                      name="file"
                      id="file"
                      onChange={handleFileChange}
                      accept=".xls,.xlsx,.csv"
                    />
                  </form>
                </label>
                {file && (
                  <div className="file-name-display mt-3">
                    <p>
                      <strong>{t('SELECTEDFILE')}:</strong> {file.name}
                    </p>
                  </div>
                )}
                <div className="file-name-display mt-3">
                  <p>
                    <button
                      className="btn btn-link"
                      onClick={handleDownloadSample}
                    >
                      {t('DOWNLOADSAMPLE')}
                    </button>
                  </p>
                </div>

                <div className="d-flex justify-content-between py-3 file-size">
                  <p className="mb-0">{t('SUPPORTEDFORMAT')}: xlsx</p>
                  <p className="mb-0">{t('MAXIMUMSIZE')}: 2MB</p>
                </div>
                <button
                  type="button"
                  onClick={handleSubmit}
                  className={`import-btn mt-1 ${importLoading ? 'disable-btn' : ''}`}
                  disabled={importLoading}
                >
                  {importLoading ? t('IMPORTING') + '...' : t('IMPORT')}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
